import React from 'react';
import { CaretRight } from '@phosphor-icons/react';
import { Link, useLocation } from 'react-router-dom';

const TemplateBreadcrumb = ({ colors = {} }) => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    // Format path to Title Case: 'contact-us' -> 'Contact Us'
    const formatTitle = (text) => {
        return text.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };

    // Determine the main title (last part of the path, or 'Home' if empty)
    const mainTitle = pathnames.length > 0 ? formatTitle(pathnames[pathnames.length - 1]) : 'Home';

    return (
        <div className="w-100 mb-5" style={{ padding: '16px 0', borderBottom: '1px solid #f0f0f0', backgroundColor: colors.breadcrumbBg || '#F4F4F4' }}>
            <div className="container d-flex justify-content-between align-items-center">
                <span className="fw-bold text-dark text-14" style={{textTransform: 'capitalize'}}>{mainTitle}</span>
                <div className="d-flex align-items-center gap-1 text-12 text-dark">
                    <i className="ph ph-house text-14"></i>
                    <Link to="/" className="text-dark text-decoration-none hover-text-primary">
                        Home
                    </Link>
                    {pathnames.length > 0 && <CaretRight size={10} className="text-dark mx-1" />}
                    {pathnames.map((value, index) => {
                        const last = index === pathnames.length - 1;
                        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                        const title = formatTitle(value);

                        return last ? (
                            <span key={to} style={{textTransform: 'capitalize'}}>{title}</span>
                        ) : (
                            <React.Fragment key={to}>
                                <Link to={to} className="text-dark text-decoration-none hover-text-primary" style={{textTransform: 'capitalize'}}>
                                    {title}
                                </Link>
                                <CaretRight size={10} className="text-dark mx-1" />
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TemplateBreadcrumb;
